import { Component, OnDestroy, OnInit } from '@angular/core';
import { unsubscribe } from '@app/utils';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Passenger } from '@app/models/micro';
import { PassengerService } from '@app/services/micro/passenger.service';
/**
  Componente para mostrar un modal relacionado con la necesidad de sillas especiales.
  Este componente permite gestionar la visualización de pasajeros que requieren sillas especiales
  y cerrar el modal cuando sea necesario.
**/
@Component({
    selector: 'app-need-chair-modal',
    templateUrl: './need-chair-modal.component.html',
    styleUrls: ['./need-chair-modal.component.scss'],
    standalone: false
})
export class NeedChairModalComponent implements OnInit, OnDestroy {

  /**
    Lista de suscripciones para gestionar la desuscripción en el ciclo de vida del componente.
  **/
    subs: Subscription[] = [];

    /**
      Lista de pasajeros que requieren sillas especiales.
    **/
    passengers: Passenger[] = [];

  constructor(
    private modalService: NgbModal,
    private _passengers: PassengerService,
  ) {}

  ngOnInit() {
    this.initPage();
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }

  initPage() {
    const passengersSelected = this._passengers.getPassengerSelection()
    this.passengers = passengersSelected.filter(passenger => passenger.hasChair)
  }
  /**
    Cierra todos los modales abiertos.
    Este método se ejecuta cuando el usuario decide cerrar el modal.
    @return void - No retorna ningún valor.
  **/
  onClose() {
    this.modalService.dismissAll();
  }
}
